import request from '@/utils/request'
import cacheRequest from '@/utils/request/cacheRequest'
import store from '@/store'

export const payOrderUrl = '/customer/default/pay-order'
// Add user
// 添加用户
export function addUser(data) {
  return request({
    url: '/customer/default/add-user',
    data
  })
}

// Restore the user
// 恢复用户
export function restoreUser(data) {
  return request({
    url: '/customer/default/restore-user',
    data
  })
}

// Make payment for order
// 对 order 进行付款
export function payOrder(data) {
  return request({
    url: payOrderUrl,
    data
  })
}

// User adds order
// 用户添加订单
export function addOrder(data) {
  return request({
    url: '/customer/default/add-order',
    data
  })
}

// User adds order - venue sub group order
// 用户添加订单
export function addVenueSubGroupOrder(data) {
  return request({
    url: '/customer/default/add-venue-sub-group-order',
    data
  })
}

// 后端 B18 跟改：多店先付款页一进来建单用这个 —— 同一个接口，失败时不弹任何提示（requestMixin 认 silentErrors），
// 把错误原样交给付款页，由它说一句顾客看得懂的话、带顾客回组车（views/payment/index.vue _createSubGroupOrder）。资料页（后付款）照旧用上面那个
export function addVenueSubGroupOrderQuietly(data) {
  return request({
    url: '/customer/default/add-venue-sub-group-order',
    data,
    silentErrors: true
  })
}

// Make payment for order - venue sub group order
// 对 order 进行付款
export function payVenueSubGroupOrder(data) {
  return request({
    url: '/customer/default/pay-venue-sub-group-order',
    data
  })
}

// Get information about order
// 获取 order 的相关信息
export function getOrder(data) {
  return request({
    url: '/customer/default/get-order',
    data
  })
}

// Get the product list
// 获取 product 的列表
export function getProductList(data) {
  return request({
    url: '/customer/default/get-product-list',
    data
  })
}

// 多版本菜单 B6（U-B6-2 review 第 2 轮 G7）：后台读商品表（购物车页进店的本地核对，顾客什么都没点）—— 同一个接口，
// 失败时不弹任何提示（requestMixin 认 silentErrors：断网那句、后端那句都不弹），把错误原样交给调用方
export function getProductListQuietly(data) {
  return request({
    url: '/customer/default/get-product-list',
    data,
    silentErrors: true
  })
}

// Obtain product information
// 获取 product 的相关信息
export function getProduct(data) {
  return cacheRequest({
    url: '/customer/default/get-product',
    data
  })
}

// Gets orders under user
// 获取 user 下的 orders
export function getUserOrders(data) {
  return request({
    url: '/customer/default/get-user-orders',
    data
  })
}

// Get relevant information about the revenue group
// 获取 venue group 的相关信息
export function getVenueGroup(data) {
  return request({
    url: '/customer/default/get-venue-group',
    data
  })
}

// Get relevant information about the venue
// 获取 venue 的相关信息
export function getVenue(data) {
  return cacheRequest({
    url: '/customer/default/get-venue',
    data
  })
}

// Get Pictures
// 获取图片资源
export function getImage(data) {
  return request({
    url: '/customer/default/get-image',
    data
  })
}

// Get customer related information
// 获取客户的相关信息
export function getUser(data) {
  // force to assign venue id
  if (!data.venueId && store.state.venueId) {
    data.venueId = store.state.venueId
  }
  return cacheRequest({
    url: '/customer/default/get-user',
    data
  })
}

// Get menu related information
// 获取菜单的相关信息
export function getMenu(data) {
  return request({
    url: '/customer/default/get-menu',
    data
  })
}

// 多版本菜单批 L2：购物车整页刷新后补取点单链接的桌号表（顾客什么都没点）—— 同一个接口、同一条请求链路（预览头、seed 照旧），
// 失败时不弹任何提示（requestMixin 认 silentErrors），调用方退回全名册
export function getMenuQuietly(data) {
  return request({
    url: '/customer/default/get-menu',
    data,
    silentErrors: true
  })
}

// Download tax invoice
export function getInvoice(data, type) {
  let url = '/customer/default/get-invoice'
  if (type === 'subGroup') {
    url = '/customer/default/get-sub-group-invoice'
  }

  return request({
    url: url,
    data,
    responseType: 'blob'
  })
}

export function updateUser(data) {
  return request({
    url: '/customer/default/update-user',
    data
  })
}

export function updateOrder(data) {
  return request({
    url: '/customer/default/update-order',
    data
  })
}

// Check member number
// 校验折扣号码是否可用
export function verifyDiscount(data) {
  return request({
    url: '/customer/default/verify-discount',
    data
  })
}

// Get table related information
// 获取 table 的相关信息
export function getTableExtra(data) {
  return request({
    url: '/customer/default/get-table-extra',
    data
  })
}

// Answer campaign
// 记录广告
export function answerCampaign(data) {
  return request({
    url: '/customer/default/answer-campaign',
    data
  })
}

// Official website - Form submission
// 官网 - 提交表单
export function getForm(data) {
  return request({
    url: '/user/default/contact',
    data
  })
}

export function otherAction(data) {
  return request({
    url: '/customer/default/other-action',
    data
  })
}

// Delivery - Get delivery cost
// delivery - 获取第三方的信息
export function getDeliveryCost(data) {
  return request({
    url: '/customer/default/get-delivery-cost',
    data
  })
}

// Get stripe payment information
// 获取 'stripe 支付'的信息
export function createStripePaymentIntent(data) {
  return request({
    url: '/customer/default/create-stripe-payment-intent',
    data
  })
}

// get safe2pay oauth token
export function getSafe2payOauthToken(data, id) {
  return request({
    url: '/customer/default/get-safe2pay-js-token?id=' + id,
    data
  })
}

export function getWindcaveSession(data, id) {
  return request({
    url: '/customer/default/get-windcave-session?id=' + id,
    data
  })
}

// 支付相关

// // Get client secret
// // 获取 client secret
// export function getClientSecret(data) {
//   return request({
//     url: `/customer/default/create-stripe-payment-intent?id=${data.id}`,
//   })
// }

// Poll an order's payment status (used by the Adyen completion fallback).
// 轮询订单支付状态(Adyen 完成兜底用)
// data.type: pass 'venueSubGroupOrder' for sub-group orders — venue orders and sub-group orders
// live in different tables with independent ids, so omitting the type would make the backend look
// the id up in the wrong table (and possibly read a stranger's order).
export function checkOrderPayment(data) {
  return request({
    url: `/customer/default/check-order-payment?id=${data.id}${data.type ? `&type=${data.type}` : ''}`
  })
}

// AI Recommendation
// AI 推荐
export function getAIRecommendations(data) {
  return request({
    url: '/customer/default/get-recommendations',
    data
  })
}
